/*
 * JHR sign-up forms (29 Sep 2026) - replaces Klaviyo's forms: every form[data-jhr-signup] (snippets/jhr-signup-form.liquid)
 * posts to our app, POST /apps/jhr/signup {email, source, hp, ms, page} -> {ok, message} (the Klaviyo session's
 * backend, KLAVIYO_REPLACEMENT.md s11). The reply's message is shown exactly as sent, in a polite live region:
 * ok -> the fields make way for the message; not ok -> the message under the field and the form stays.
 * "hp" = a field people can't see (robots fill it in); "ms" = time from the form being seen / opened to Send (robots
 * are instant). First-party, no cookies, nothing stored. window.jhrSignup is also used by the collection strip
 * (snippets/jhr-slide-effects.liquid) and the clearance pop-up (snippets/jhr-signup-popup.liquid).
 */
(function () {
  'use strict';
  if (window.jhrSignup) return;
  var ENDPOINT = '/apps/jhr/signup';
  var BAD = "Please check your email address - that one doesn't look right.";
  var FAIL = 'Sorry - something went wrong. Please try again in a moment.';

  function post(email, source, hp, openedAt) {
    // ms is left out when the opening wasn't seen: the app reads a missing ms as "unknown", but Number(null) is 0.
    // Sent as an ordinary form post (URL-encoded): the app reads JSON too, but this is exactly what the no-script
    // fallback sends, so both paths are the same. (Aaron's first real test on 30 Sep failed on the app side - it hashed
    // the connection's IP with the email-only hasher - not because of the format; fixed there.)
    var body = new URLSearchParams();
    body.set('email', email);
    body.set('source', source);
    body.set('hp', hp || '');
    body.set('page', location.pathname);
    if (openedAt) body.set('ms', String(Date.now() - openedAt));
    return fetch(ENDPOINT, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8', Accept: 'application/json' },
      body: body.toString()
    }).then(function (r) {
      return r.json().catch(function () { return null; });
    }).then(function (d) {
      return { ok: !!(d && d.ok), message: (d && typeof d.message === 'string' && d.message) || FAIL };
    }).catch(function () {
      return { ok: false, message: FAIL };
    });
  }
  function looksLikeEmail(s) { return /^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(s); }
  /** The moment the form was first seen or opened (the pop-up and the cart box call this when they open). */
  function opened(form) { if (form && !form.__jhrOpenedAt) form.__jhrOpenedAt = Date.now(); }

  function bind(form) {
    if (!form || form.__jhrBound) return;
    form.__jhrBound = true;
    var input = form.querySelector('input[type="email"]');
    var btn = form.querySelector('.jhr-su__btn');
    var msg = form.querySelector('.jhr-su__msg');
    var fields = form.querySelector('.jhr-su__fields');
    var hp = form.querySelector('input[name="hp"]');
    if (!input || !btn || !msg) return;
    var btnHtml = btn.innerHTML;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) if (entries[i].isIntersecting) { opened(form); io.disconnect(); return; }
      });
      io.observe(form);
    }
    input.addEventListener('focus', function () { opened(form); });
    function say(text, isError) {
      msg.className = 'jhr-su__msg' + (isError ? ' jhr-su__msg--err' : '');
      msg.textContent = text;
      if (isError) input.setAttribute('aria-invalid', 'true'); else input.removeAttribute('aria-invalid');
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (btn.disabled) return;
      var email = (input.value || '').trim();
      if (!looksLikeEmail(email)) { say(BAD, true); input.focus(); return; }
      // No "opened" stamp here: if the form's opening was never seen (old browser, background tab), send ms = null
      // (the app then skips its too-fast check) - stamping it now would send ~0 ms and a real person would be
      // treated as a robot (found in testing 29 Sep).
      say('', false);
      btn.disabled = true;
      btn.textContent = 'Sending...';
      var source = form.getAttribute('data-source');
      post(email, source, hp && hp.value, form.__jhrOpenedAt).then(function (res) {
        if (res.ok) {
          if (fields) fields.hidden = true;
          msg.className = 'jhr-su__msg jhr-su__msg--done';
          msg.textContent = res.message;
        } else {
          btn.disabled = false;
          btn.innerHTML = btnHtml;
          say(res.message, true);
          input.focus();
        }
        try { form.dispatchEvent(new CustomEvent('jhr:signup', { bubbles: true, detail: { source: source, ok: res.ok } })); } catch (err) { /* old browsers */ }
      });
    });
  }
  function scan(root) {
    var forms = (root || document).querySelectorAll('form[data-jhr-signup]');
    for (var i = 0; i < forms.length; i++) bind(forms[i]);
  }
  window.jhrSignup = { post: post, bind: bind, scan: scan, opened: opened, looksLikeEmail: looksLikeEmail, BAD: BAD };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();
})();
